import { Route } from '@angular/router';

/** Ticket module under `/ticket/...` (default: `ticket/ticket-detail`). */
export const ticketRoutes: Route = {
    path: 'ticket',
    data: { title: 'ticket' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'ticket-detail' },
        {
            path: 'ticket-detail',
            loadComponent: () =>
                import('./ticket-detail/ticket-detail.component').then((m) => m.TicketDetailComponent),
            data: { title: 'ticket-detail' },
        },
    ],
};
